import { useQuery } from "@tanstack/react-query"

import { getMostRecentMail } from "./api"
import { QUERY_KEYS } from "../../constants"
import { useUserQuery } from "../queries"

export const useMostRecentMailQuery = () => {
  const { user } = useUserQuery()

  return useQuery({
    queryKey: [QUERY_KEYS.RECENT_MAIL],
    queryFn: getMostRecentMail,
    enabled: !!user,
  })
}
